import React from 'react';
import { useTheme } from '@mui/material';
export default function SVGBackground(_ref) {
  var width = _ref.width,
    height = _ref.height,
    shift = _ref.shift;
  var theme = useTheme();
  return React.createElement("rect", {
    width: width + shift * 2,
    height: height,
    fill: theme.palette.background.default
  });
}